import { Dialog } from "@mui/material";
import { useState } from "react";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import { IDataCategorias } from "../../types/api/estoque/pesquisar-categorias";
import MultipleChipsField from "../BaseInputs/MultipleChipsField";

export default function SelectCategoriaPrincipal({
  value,
  onChange,
  required = false,
  error = false,
}: SelectSetorProps) {
  const [openModal, setOpenModal] = useState(false);

  const handleClose = () => setOpenModal(false);

  return (
    <>
      <MultipleChipsField
        value={value}
        label="Categoria Principal"
        formatChipLabel={(item) => `${item.id} - ${item.nome}`}
        onClick={() => setOpenModal(true)}
        error={!!error}
        helperText={error ? "Campo obrigatório" : ""}
      />

      {openModal && (
        <Dialog fullWidth maxWidth="sm" open={openModal} onClose={handleClose}>
          <DialogContentSelectGeneric
            {...{ handleClose }}
            multiple
            title="Selecionar categoria principal"
            queryPath="comercial/configuracoes/pesquisar-categorias"
            getItemKey={(item) => item?.id ?? 0}
            getItemLabel={(item) => (item ? `${item.id} - ${item.nome}` : "")}
            defaultValue={value ?? []}
            onChange={(value) => {
              onChange(value as IDataCategorias[]);
              handleClose();
            }}
          />
        </Dialog>
      )}
    </>
  );
}

interface SelectSetorProps {
  value: IDataCategorias[] | null;
  onChange: (arg: IDataCategorias[] | null) => void;
  required?: boolean;
  error?: boolean;
}
